(function () {
  let attempts = 0; // Compteur d'essais
  const maxAttempts = 20; // Nombre maximum d'essais (1 par seconde)
  var modal = "";
  var captionText = "";
  const intervalId = setInterval(() => {
    // Récupérer toutes les checkboxes
    const checkboxes = document.querySelectorAll(
      ".pplr_checkbox_l input[type='checkbox']"
    );
    // Récupérer les champs associés
    const faceAvantField = document.querySelector(".pplr-face-avant");
    const faceArriereField = document.querySelector(".pplr-face-arrire-15");

    // Vérifier si des checkboxes et champs existent
    if (checkboxes.length > 0 && faceAvantField && faceArriereField) {
      clearInterval(intervalId); // Stopper l'intervalle une fois les éléments trouvés

      // Fonction pour mettre à jour les états des checkboxes, classes, et champs
      function updateCheckboxes(selectedCheckbox) {
        checkboxes.forEach((checkbox) => {
          const parentLabel = checkbox.closest(".pplr_checkbox_l");
          if (checkbox === selectedCheckbox) {
            checkbox.checked = true; // Cocher la checkbox sélectionnée
            parentLabel?.classList.add("active"); // Ajouter la classe 'active'
          } else {
            checkbox.checked = false; // Décoche toutes les autres checkboxes
            parentLabel?.classList.remove("active"); // Retirer la classe 'active'
          }
        });

        // Afficher ou masquer les champs associés
        if (selectedCheckbox.dataset.value === "Face avant") {
          faceAvantField.style.display = "block";
          faceAvantField.nextSibling.style.display = "block";

          faceArriereField.style.display = "none";
          faceArriereField.nextSibling.style.display = "none";
        } else if (selectedCheckbox.dataset.value === "Face arrière") {
          faceAvantField.style.display = "none";
          faceAvantField.nextSibling.style.display = "none";
          faceArriereField.style.display = "block";
          faceArriereField.nextSibling.style.display = "block";
        }
      }

      // Ajouter un événement de clic aux checkboxes
      checkboxes.forEach((checkbox) => {
        const parentLabel = checkbox.closest(".pplr_checkbox_l");
        if (parentLabel) {
          parentLabel.addEventListener("click", function (event) {
            event.preventDefault(); // Empêcher le comportement par défaut du clic
            updateCheckboxes(checkbox); // Mettre à jour les checkboxes, classes, et champs
          });
        }
      });

      // Initialiser l'état en cochant la première checkbox si aucune n'est cochée
      const anyChecked = Array.from(checkboxes).some(
        (checkbox) => checkbox.checked
      );
      if (!anyChecked && checkboxes[0]) {
        checkboxes[0].checked = true; // Simuler un clic sur la première checkbox
        faceArriereField.style.display = "none";
        faceArriereField.nextSibling.style.display = "none";

        checkboxes[0].closest(".pplr_checkbox_l").classList.add("active");
      }

      // Les textareas sont gérés automatiquement par Zepto
      // Ils ont déjà name="properties[Face avant]" et name="properties[Face arrière (+15.-)]"
      // Pas besoin de logique supplémentaire - les valeurs sont envoyées au submit
      // Vérifier la largeur de l'écran
      if (window.matchMedia("(max-width: 768px)").matches && 1 == 2) {
        const thumbs = document.querySelector("#ProductThumbs");

        const parent = thumbs.parentNode;

        // Remplacer l'élément original par le clone

        parent.insertAdjacentHTML("beforeend", '<div class="rk_thumbs"></div>');
        // Sélectionner tous les liens avec la classe 'product-single__thumbnail-link'
        const links = thumbs.querySelectorAll(
          "#ProductThumbs .product-single__thumbnail a"
        );
        thumbs.remove();
        const newCont = document.querySelector(".rk_thumbs");
        // Parcourir chaque lien et le remplacer par son clone
        links.forEach((link) => {
          const img = link.getAttribute("href"); // Sélectionner la balise <img> dans le clone
          const newimage = document.createElement("div");
          const imgSrc = link.querySelector("img").getAttribute("src");
          if (img) {
            newimage.addEventListener("click", function (event) {
              event.preventDefault();

              showModal(img);
            });
          }

          newimage.setAttribute(
            "style",
            "background-image:url(" + imgSrc + ");"
          );
          newCont.appendChild(newimage);
        });

        const gallery = document.querySelector(".product-single__gallery");

        // Vérifier si l'élément existe pop up custom
        if (gallery && 1 == 2) {
          // Ajouter le nouveau contenu HTML à la fin de l'élément
          const newContent = `
          <div id="imageModal" class="modal_product" role="dialog" aria-label="Image View Modal">
            <button class="close" aria-label="Close" tabindex="0"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192"><path d="M150 42 42 150M150 150 42 42" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
            <div class="modal-content" id="fullImage">          </div>
 
          </div>
        `;
          gallery.insertAdjacentHTML("beforeend", newContent);
          const span = document.querySelector(".close");
          modal = document.getElementById("imageModal");

          const image = document.getElementById("fullImage");

          // Ajouter un gestionnaire d'événements pour cliquer en dehors de l'image
          modal.addEventListener("click", function (event) {
            // Vérifie si le clic est en dehors de l'image
            if (event.target !== image && !image.contains(event.target)) {
              closeModal();
            }
          });

          span.addEventListener("click", closeModal);
          modal.addEventListener("click", function (event) {
            if (event.target === modal) {
              closeModal();
            }
          });
        }
      }
    } else if (attempts >= maxAttempts) {
      clearInterval(intervalId); // Stopper l'intervalle après 20 secondes
    }

    attempts++; // Incrémenter le compteur d'essais
  }, 1000); // Vérification toutes les secondes

  function showModal(img) {
    const modalImg = document.getElementById("fullImage");

    modal.style.visibility = "visible";
    modal.scrollTop = 0;
    requestAnimationFrame(() => {
      modal.style.opacity = "1";
    });

    modalImg.setAttribute("style", "background-image:url(" + img + ");");

    document.addEventListener("keydown", handleEscape, false);
  }

  function handleEscape(event) {
    if (event.key === "Escape" || event.key === "Esc") {
      closeModal();
    }
  }

  function closeModal() {
    modal.style.opacity = "0";
    modal.addEventListener(
      "transitionend",
      () => {
        modal.style.visibility = "hidden";
      },
      {
        once: true,
      }
    );

    document.removeEventListener("keydown", handleEscape, false);
  }



})();
